import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const VisitorModalWrapper = styled(Modal)`
  &.visitor-modal{
    width: 850px !important;
   
  }
  .ant-btn-primary{
    background-color: #0B2A1B !important;
  }
  .ant-modal-body{
    padding: 0;
  }
  .btn-success{
    /* Match the dark green used for the modal title / primary buttons */
    background-color:#0B2A1B !important;
    border-color:#0B2A1B;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
      color: #0B2A1B;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
`;

export default WithDirection(VisitorModalWrapper);